module.exports = __webpack_public_path__ + "img/EXTERIOR-JIMNY-2.98643f92.jpg";